import { useLazyLoadQuery } from 'react-relay';
import { ATLASSIAN_ACCOUNT_USER_QUERY } from 'graphql/AtlassianAccountUserQuery';
import { AtlassianAccountUserQuery } from 'graphql/__generated__/AtlassianAccountUserQuery.graphql';
import { AtlassianAccountUserFragment$data } from '~graphql/__generated__/AtlassianAccountUserFragment.graphql';

const useLoggedInUser =
  (): Partial<AtlassianAccountUserFragment$data> | null => {
    const atlassianUserData = useLazyLoadQuery<AtlassianAccountUserQuery>(
      ATLASSIAN_ACCOUNT_USER_QUERY,
      {},
      { fetchPolicy: 'store-or-network' },
    );

    return atlassianUserData?.me?.user || null;
  };

export default useLoggedInUser;
